import RedtailAppDetails from './apps/RedtailAppDetails.vue';
import WealthboxAppDetails from './apps/WealthboxAppDetails.vue';
import SalesforceAppDetails from './apps/SalesforceAppDetails.vue';


export const appDetailsComponentMap = {
  'Redtail': RedtailAppDetails,
  'Wealthbox': WealthboxAppDetails,
  'Salesforce': SalesforceAppDetails,
};
